export default defineNuxtPlugin(nuxtApp => {
  const cartStore = useCartStore()
  const paymentStore = usePaymentStore()
  const { showToast } = useToast()
  const { $t } = useNuxtApp()

  const route = useRoute()
  // Overrides localstorage coupon with coupon given in url
  paymentStore.$persistedState.isReady().then(async () => {
    const code = route.query?.c || route.query?.C

    if (!code || route.name?.toString().includes('cart')) { return }

    try {
      const data = await paymentStore.addCoupon(code)
      if (data) {
        showToast({
          id: 'coupon',
          message: $t('general/coupon-added-to-shoppingbag', {
            KORTINGSCODE: code
          })
        })
      }
    } catch (e) {
      console.log(e)
    }
  })

  // Overrides shoptoken with shoptoken given in url
  cartStore.$persistedState.isReady().then(async () => {
    if (cartStore.shopToken?.value) {
      try {
        const shopToken = jwtDecode(cartStore.shopToken.value)
        if (shopToken?.exp && shopToken.exp < (Date.now() / 1000)) {
          cartStore.shopToken.value = null
        }
      } catch (e) {
        cartStore.shopToken.value = null
      }
    }

    if (route.query?.shoptoken) {
      try {
        const shopToken = jwtDecode(route.query.shoptoken.toString())
        if (shopToken) {
          cartStore.shopToken = route.query.shoptoken.toString()
        }
      } catch (e) {

      }
    }
    if (route.query?.clearshoptoken) {
      cartStore.shopToken = null
    }
  })
})
